(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabFiles', TabFiles);

    TabFiles.$inject = ['$resource'];

    function TabFiles ($resource) {
        var resourceUrl =  'api/tab-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'load': {
                url:'api/tab-files/inactive',
                method: 'GET',
                isArray: true
            },
            'update': { method:'PUT' },
            'enable': {
                url:'api/tab-files/enable',
                method:'PUT'
            }
        });
    }
})();
